/**
 * VideoPlayer
 * @description Wrapper around video, with click to play interaction.
 */
 if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {

      super();
      this.parentVideo = this.closest('.video');
      this.element = this;
      this.videoElement = this.querySelector('[data-video]');
      this.source = this.videoElement.querySelector('source');

      // Check for video click events
      this.element.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.videoElement.paused === true) {
          this.videoElement.play();
          this.parentVideo.classList.add('is-playing');
          this.element.classList.add('playing');
        }
        else {
          this.videoElement.pause();
          this.parentVideo.classList.remove('is-playing');
          this.element.classList.remove('playing');
        }
      });

      // Remove play state class from element when the video is done.
      this.videoElement?.addEventListener('ended', () => {
        this.parentVideo.classList.remove('is-playing');
        this.element.classList.remove('playing');
      });
    }

  }
  window.VideoPlayer = VideoPlayer;
  customElements.define('video-player', VideoPlayer);
}